export enum Tab
{
	kids = 'kids',
	goals = 'goals',
	parent = 'parent',	// class parent's view
}